export var Month;

(function (Month) {
  Month[Month["JAN"] = 0] = "JAN";
  Month[Month["FEB"] = 1] = "FEB";
  Month[Month["MAR"] = 2] = "MAR";
  Month[Month["APR"] = 3] = "APR";
  Month[Month["MAY"] = 4] = "MAY";
  Month[Month["JUN"] = 5] = "JUN";
  Month[Month["JUL"] = 6] = "JUL";
  Month[Month["AUG"] = 7] = "AUG";
  Month[Month["SEP"] = 8] = "SEP";
  Month[Month["OCT"] = 9] = "OCT";
  Month[Month["NOV"] = 10] = "NOV";
  Month[Month["DEC"] = 11] = "DEC";
})(Month || (Month = {}));

export var Day;

(function (Day) {
  Day[Day["SUN"] = 0] = "SUN";
  Day[Day["MON"] = 1] = "MON";
  Day[Day["TUE"] = 2] = "TUE";
  Day[Day["WED"] = 3] = "WED";
  Day[Day["THU"] = 4] = "THU";
  Day[Day["FRI"] = 5] = "FRI";
  Day[Day["SAT"] = 6] = "SAT";
})(Day || (Day = {}));

export var DaysInOrder = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//# sourceMappingURL=types.js.map